import React from 'react'
import PropTypes from 'prop-types'

import cl from 'classnames'
import { Paper, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { getPrice } from 'common/utils/conciergeDigitalInvoiceItem'
import theme from 'artkive/utils/theme'

const useStyles = makeStyles(({ breakpoints }) => ({
  root: {
    border: `2px solid ${theme.colors.sky[300]}`,
    borderRadius: 8,
    padding: 16,
    textAlign: 'center',
    [breakpoints.up('md')]: {
      width: 320,
    },
  },
  price: {
    fontSize: '1.5rem',
    lineHeight: 1.5,
  },
}))

const ValueLabelComponent = ({ value, className }) => {
  const classes = useStyles()

  return (
    <Paper elevation={0} className={cl(classes.root, className)}>
      <Typography className='test-pricing-label'>{value} Art Pieces</Typography>
      <Typography variant='h6' className={cl(classes.price, 'test-pricing-amount')}>
        {getPrice(value)}
      </Typography>
    </Paper>
  )
}

ValueLabelComponent.propTypes = {
  value: PropTypes.number.isRequired,
  className: PropTypes.string,
}

export default ValueLabelComponent
